import { CardMedia, SxProps, Theme } from '@mui/material';
import { Card } from 'common';

export function CompanyLogo({
    src,
    sx,
    containerSx,
}: {
    src: string;
    sx?: SxProps<Theme>;
    containerSx?: SxProps<Theme>;
}) {
    return (
        <Card
            rootProps={{
                sx: [
                    (t) => ({
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        [t.breakpoints.down('lg')]: {
                            boxShadow: 'none',
                            backgroundColor: 'transparent',
                        },
                    }),
                    ...(Array.isArray(containerSx) ? containerSx : [containerSx]),
                ],
                'data-testid': 'company-logo',
            }}
            content={
                <CardMedia
                    component="img"
                    height="100%"
                    image={src}
                    sx={(t) => ({
                        objectFit: 'contain',
                        [t.breakpoints.down('lg')]: {
                            width: 'auto',
                            maxWidth: '100%',
                            maxHeight: 64,
                        },
                    })}
                    alt="Company Logo"
                />
            }
            contentProps={{
                sx: [
                    (t) => ({
                        maxWidth: '250px',
                        maxHeight: '250px',
                        [t.breakpoints.down('lg')]: {
                            p: 0,
                            '&:last-child': { pb: 0 },
                        },
                    }),
                    ...(Array.isArray(sx) ? sx : [sx]),
                ],
            }}
        />
    );
}
